import { Product, ProductId } from "../../../../commons/specs/product";
import { Brand } from "../../../../commons/types/brand";
import AvailabilityOverlayBase from "../../../commons/container/ProductDetails/AvailabilityOverlay";
import { useGetMobilePrintDataItem } from "../../libs/hooks/use-get-print-data-item";

interface OuterProps {
  variantId?: ProductId;
  product: Product;
  brand: Brand;
}

const AvailabilityOverlay = ({ product, variantId, brand }: OuterProps) => {
  const { getPrintItem } = useGetMobilePrintDataItem();

  return (
    <AvailabilityOverlayBase
      product={product}
      brand={brand}
      variantId={variantId}
      getPrintItem={getPrintItem}
      hasInternetConnectivity
    />
  );
};

export default AvailabilityOverlay;
